export function push(position, normal, color, p, n) {
  position.push(...p); normal.push(...n); color.push(0.6, 0.58, 0.54);
}
